import axiosInstance from '../helpers/api';

export interface CountyDeal {
  id: number;
  apn: string;
  property_address: string;
  property_city: string;
  property_zip: string;
  deed_type: string;
  deed_type_label: string;
  deed_date: string;
  current_owner: string;
  ownership_category: string;
  ownership_years: number;
  is_absentee: number;
  mailing_city: string;
  mailing_state: string;
  property_type: string;
  bedrooms: number | null;
  bathrooms: number | null;
  living_area: number | null;
  lot_size: number | null;
  year_built: number | null;
  assessed_value: number | null;
  estimated_arv: number | null;
  as_is_value: number | null;
  flip_roi: number | null;
  flip_profit: number | null;
  lead_tier: string;
  lead_score: number;
  score_reasons: string;
  trigger_type: string;
  status: string;
  status_notes: string | null;
  assigned_to: string | null;
  owner_phone: string | null;
  last_called_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface CountyDealDetail extends CountyDeal {
  previous_owner: string;
  mailing_address: string;
  mailing_zip: string;
  estimated_repair_cost: number | null;
  total_comps: number;
  comp_data: any;
  call_notes: string | null;
  first_detected_at: string;
  last_scanned_at: string;
}

export interface CountyDealSummary {
  total_deals: number;
  tier1_count: number;
  tier2_count: number;
  tier3_count: number;
  new_count: number;
  contacted_count: number;
  death_deeds: number;
  foreclosures: number;
  probate_count: number;
  trust_transfers: number;
  absentee_count: number;
  avg_lead_score: number;
  avg_assessed_value: number;
  last_scan: string;
}

export interface CountyDealFilters {
  page?: number;
  per_page?: number;
  sort?: string;
  order?: 'asc' | 'desc';
  tier?: string;
  trigger_type?: string;
  city?: string;
  zip?: string;
  deed_type?: string;
  status?: string;
  category?: string;
  min_score?: number;
  min_value?: number;
  max_value?: number;
}

export interface MLSHistory {
  listing_id: string;
  unparsed_address: string;
  list_price: number;
  close_price: number;
  close_date: string;
  standard_status: string;
  bedrooms: number;
  bathrooms: number;
  living_area: number;
  year_built: number;
  list_agent_name: string;
  list_office_name: string;
  buyer_agent_name: string;
  buyer_office_name: string;
}

const countyDealService = {
  async getDeals(filters: CountyDealFilters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });
    const { data } = await axiosInstance.get(`/county-deals/opportunities?${params.toString()}`);
    return data;
  },

  async getSummary() {
    const { data } = await axiosInstance.get('/county-deals/summary');
    return data;
  },

  async getFilters() {
    const { data } = await axiosInstance.get('/county-deals/filters');
    return data;
  },

  async getDeal(id: number) {
    const { data } = await axiosInstance.get(`/county-deals/${id}`);
    return data;
  },

  async updateStatus(id: number, status: string, notes?: string, assigned_to?: string) {
    const { data } = await axiosInstance.put(`/county-deals/${id}/status`, { status, notes, assigned_to });
    return data;
  },

  async logCall(id: number, notes: string) {
    const { data } = await axiosInstance.put(`/county-deals/${id}/call-log`, { notes });
    return data;
  },

  async enrichMLS() {
    const { data } = await axiosInstance.post('/county-deals/enrich-mls');
    return data;
  },

  async getCities() {
    const { data } = await axiosInstance.get('/county-deals/cities');
    return data;
  },
};

export default countyDealService;
